// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimParentLookupModel {
    static getAttributeTypeMap() {
        return ClaimParentLookupModel.attributeTypeMap;
    }
}
ClaimParentLookupModel.discriminator = undefined;
ClaimParentLookupModel.additionalProperties = false;
ClaimParentLookupModel.attributeTypeMap = [
    {
        "name": "parentId",
        "baseName": "parentId",
        "type": "number"
    },
    {
        "name": "id",
        "baseName": "id",
        "type": "number"
    },
    {
        "name": "code",
        "baseName": "code",
        "type": "string"
    },
    {
        "name": "description",
        "baseName": "description",
        "type": "string"
    },
];
//# sourceMappingURL=claimParentLookupModel.js.map